export const MODULE_NAME = 'axp-travel-home-search';
export const ROOT_MODULE_NAME = 'axp-consumer-travel-root';
